<div class="admin-shell">
  <header class="admin-header">
    <button class="back-dashboard-btn" (click)="exitPanel()">⟵ Back to Dashboard</button>
    <span class="admin-title">Admin</span>
    <nav class="admin-tabs">
      <button class="admin-tab" [class.active]="activeTab === 'accounts'"     (click)="activeTab = 'accounts'">Accounts</button>
      <button class="admin-tab" [class.active]="activeTab === 'tasks'"        (click)="activeTab = 'tasks'">Polling Tasks</button>
      <button class="admin-tab" [class.active]="activeTab === 'feature-flags'" (click)="activeTab = 'feature-flags'">Feature Flags</button>
    </nav>
  </header>

  <!-- ── Accounts ─────────────────────────────────────────────────────────── -->
  <section *ngIf="activeTab === 'accounts'" class="admin-section">

    <div class="admin-actions">
      <button class="save-btn" (click)="exitPanel()">Back to Dashboard</button>
      <button class="save-btn" (click)="refreshAccounts()">Refresh Users</button>
      <input class="search-input" [(ngModel)]="searchAccountText" placeholder="Search accounts..." />
    </div>

    <div *ngIf="accountsError" class="admin-error">{{ accountsError }}</div>
    <div *ngIf="accountsLoading" class="admin-loading">Loading…</div>

    <table *ngIf="!accountsLoading" class="admin-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>User</th>
          <th>Label</th>
          <th>Email</th>
          <th>Ship</th>
          <th>Fleet</th>
          <th>Service</th>
          <th>Admin</th>
          <th>Active</th>
          <th>Locked</th>
          <th>Last Used</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of filteredAccounts" [class.row-inactive]="!a.isActive">
          <td class="cell-id">{{ a.id }}</td>
          <td>
            <span class="acct-name">{{ a.userName || '—' }}</span>
            <span class="acct-uid">{{ a.userId }}</span>
          </td>
          <td>{{ a.label || '—' }}</td>
          <td>{{ a.email || '—' }}</td>
          <td>
            <span *ngIf="a.shipName">{{ a.shipName }}</span>
            <span *ngIf="a.shipLevel" class="cell-dim"> Lv{{ a.shipLevel }}</span>
            <span *ngIf="!a.shipName && !a.shipLevel">—</span>
          </td>
          <td>{{ a.fleetName || '—' }}</td>
          <td class="cell-flag">
            <button class="flag-btn" [class.flag-on]="a.isServiceAccount"
                    (click)="toggleFlag(a, 'isServiceAccount')" title="Toggle service account">
              {{ a.isServiceAccount ? '✓' : '✗' }}
            </button>
          </td>
          <td class="cell-flag">
            <button class="flag-btn" [class.flag-on]="a.isAdmin"
                    (click)="toggleFlag(a, 'isAdmin')" title="Toggle admin">
              {{ a.isAdmin ? '✓' : '✗' }}
            </button>
          </td>
          <td class="cell-flag">
            <button class="flag-btn" [class.flag-on]="a.isActive"
                    (click)="toggleFlag(a, 'isActive')" title="Toggle active">
              {{ a.isActive ? '✓' : '✗' }}
            </button>
          </td>
          <td class="cell-flag">
            <button class="flag-btn" [class.flag-on]="a.isLocked"
                    (click)="toggleFlag(a, 'isLocked')" title="Toggle locked">
              {{ a.isLocked ? '✓' : '✗' }}
            </button>
          </td>
          <td class="cell-dim">{{ a.lastUsedAt ? a.lastUsedAt.slice(0,16).replace('T',' ') : '—' }}</td>
          <td>
            <button class="del-btn" (click)="deleteAccount(a)" title="Delete">✕</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- New account form -->
    <div class="admin-form">
      <h3 class="form-title">Add / Upsert Account</h3>
      <div class="form-row">
        <label>PSS User ID <input [(ngModel)]="newAccount.userId" placeholder="123456" /></label>
        <label>Player Name <input [(ngModel)]="newAccount.userName" placeholder="CaptainFoo" /></label>
        <label>Label <input [(ngModel)]="newAccount.label" placeholder="poller-bot-1" /></label>
      </div>
      <div class="form-row">
        <label>Email <input [(ngModel)]="newAccount.email" placeholder="bot@example.com" /></label>
        <label>Device Key <input [(ngModel)]="newAccount.deviceKey" placeholder="uuid" /></label>
      </div>
      <div class="form-row form-flags">
        <label class="flag-label"><input type="checkbox" [(ngModel)]="newAccount.isServiceAccount" /> Service Account</label>
        <label class="flag-label"><input type="checkbox" [(ngModel)]="newAccount.isAdmin" /> Admin</label>
      </div>
      <div *ngIf="newAccountError" class="admin-error">{{ newAccountError }}</div>
      <button class="save-btn" (click)="saveNewAccount()" [disabled]="newAccountSaving">
        {{ newAccountSaving ? 'Saving…' : 'Save Account' }}
      </button>
    </div>
  </section>

  <!-- ── Polling Tasks ─────────────────────────────────────────────────────── -->
  <section *ngIf="activeTab === 'tasks'" class="admin-section">

    <div *ngIf="tasksError" class="admin-error">{{ tasksError }}</div>
    <div *ngIf="tasksLoading" class="admin-loading">Loading…</div>

    <div *ngFor="let task of tasks" class="task-card" [class.task-paused]="!task.isActive">
      <div class="task-head">
        <span class="task-key">{{ task.taskKey }}</span>
        <span class="task-type badge">{{ task.taskType }}</span>
        <span class="task-schedule">{{ scheduleLabel(task) }}</span>
        <span *ngIf="task.targetId" class="task-target cell-dim">→ {{ task.targetId }}</span>
        <span class="task-spacer"></span>
        <button class="flag-btn" [class.flag-on]="task.isActive"
                (click)="toggleTaskActive(task)" title="Pause / Resume">
          {{ task.isActive ? 'Running' : 'Paused' }}
        </button>
        <button class="del-btn" (click)="deleteTask(task)" title="Delete">✕</button>
      </div>
      <div *ngIf="task.description" class="task-desc">{{ task.description }}</div>
      <div *ngIf="task.lastRunAt" class="task-last-run cell-dim">Last run: {{ task.lastRunAt.slice(0,19).replace('T',' ') }} UTC</div>

      <!-- Assigned service accounts -->
      <div class="task-accounts">
        <span class="task-accounts-label">Service accounts:</span>
        <span *ngFor="let a of task.assignedAccounts" class="acct-chip" [class.chip-inactive]="!a.isActive">
          {{ a.label || a.userName || a.userId }}
          <button class="chip-remove" (click)="unassignAccount(task, a.id)" title="Remove">✕</button>
        </span>
        <span *ngIf="task.assignedAccounts.length === 0" class="cell-dim">none</span>
      </div>

      <!-- Assign dropdown -->
      <div class="task-assign" *ngIf="serviceAccounts.length > 0 && task.ownerAccountId === null">
        <select [(ngModel)]="assignAccountId[task.id]">
          <option [ngValue]="null">— assign account —</option>
          <option *ngFor="let a of serviceAccounts"
                  [ngValue]="a.id"
                  [disabled]="isAlreadyAssigned(task, a.id)">
            {{ a.label || a.userName || a.userId }}
          </option>
        </select>
        <button class="save-btn" (click)="assignAccount(task)"
                [disabled]="!assignAccountId[task.id]">Assign</button>
        <span *ngIf="assignError[task.id]" class="admin-error inline">{{ assignError[task.id] }}</span>
      </div>
      <div *ngIf="task.ownerAccountId !== null" class="cell-dim task-owner">
        Owner task — runs with account #{{ task.ownerAccountId }}'s credentials
      </div>
    </div>

    <div *ngIf="!tasksLoading && tasks.length === 0" class="admin-empty">No polling tasks yet.</div>

    <!-- New task form -->
    <div class="admin-form">
      <h3 class="form-title">Create Polling Task</h3>
      <div class="form-row">
        <label>Task Key <input [(ngModel)]="newTask.taskKey" placeholder="top100-fleets" /></label>
        <label>Description <input [(ngModel)]="newTask.description" placeholder="Poll top 100 fleets" /></label>
      </div>
      <div class="form-row">
        <label>Type
          <select [(ngModel)]="newTask.taskType">
            <option value="top100_fleets">top100_fleets</option>
            <option value="single_fleet">single_fleet</option>
            <option value="user_battles">user_battles</option>
            <option value="user_donation_extend">user_donation_extend</option>
          </select>
        </label>
        <label *ngIf="newTask.taskType !== 'top100_fleets'">
          Target ID <input [(ngModel)]="newTask.targetId" placeholder="Alliance or User ID" />
        </label>
      </div>
      <div class="form-row">
        <label>Schedule
          <select [(ngModel)]="newTask.scheduleType">
            <option value="interval">Interval</option>
            <option value="cron">Cron</option>
          </select>
        </label>
        <label *ngIf="newTask.scheduleType === 'interval'">
          Every (seconds) <input type="number" [(ngModel)]="newTask.intervalSec" min="1" />
        </label>
        <label *ngIf="newTask.scheduleType === 'cron'">
          Cron Expression <input [(ngModel)]="newTask.cronExpression" placeholder="0 2 * * *" />
        </label>
      </div>
      <div *ngIf="newTaskError" class="admin-error">{{ newTaskError }}</div>
      <button class="save-btn" (click)="saveNewTask()" [disabled]="newTaskSaving">
        {{ newTaskSaving ? 'Saving…' : 'Create Task' }}
      </button>
    </div>
  </section>

  <!-- ── Feature Flags ───────────────────────────────────────────────────────────── -->
  <section *ngIf="activeTab === 'feature-flags'" class="admin-section">

    <!-- Sub-tabs: Flags / Grant Groups -->
    <div class="flags-subtabs">
      <button class="admin-tab" [class.active]="flagsSubTab === 'flags'"  (click)="flagsSubTab = 'flags'">Flags</button>
      <button class="admin-tab" [class.active]="flagsSubTab === 'groups'" (click)="flagsSubTab = 'groups'">Grant Groups</button>
    </div>

    <!-- ── Flags sub-tab ─────────────────────────────────────────────────── -->
    <ng-container *ngIf="flagsSubTab === 'flags'">

    <div *ngIf="flagsError" class="admin-error">{{ flagsError }}</div>
    <div *ngIf="flagsLoading" class="admin-loading">Loading…</div>

    <table *ngIf="!flagsLoading" class="admin-table">
      <thead>
        <tr>
          <th>Key</th>
          <th>Name</th>
          <th>Min Tier Rank</th>
          <th>Users</th>
          <th>Fleets</th>
          <th>Enabled</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let f of flags">
          <tr class="flag-row" (click)="expandFlag(f)" [class.flag-row-open]="expandedFlagKey === f.flagKey">
            <td class="cell-id">{{ f.flagKey }}</td>
            <td>
              <span class="acct-name">{{ f.displayName }}</span>
              <span *ngIf="f.description" class="acct-uid">{{ f.description }}</span>
            </td>
            <td class="cell-flag">{{ f.requiredTierRank }}</td>
            <td class="cell-flag">{{ f.userGrantCount ?? 0 }}</td>
            <td class="cell-flag">{{ f.fleetGrantCount ?? 0 }}</td>
            <td class="cell-flag">
              <button class="flag-btn" [class.flag-on]="f.isEnabled"
                      (click)="$event.stopPropagation(); toggleFlagEnabled(f)" [title]="f.isEnabled ? 'Disable feature' : 'Enable feature'">
                {{ f.isEnabled ? 'Disable' : 'Enable' }}
              </button>
            </td>
            <td>
              <button class="del-btn" (click)="$event.stopPropagation(); deleteFlag(f)" title="Delete">✕</button>
            </td>
          </tr>
          <!-- Expanded grants panel -->
          <tr *ngIf="expandedFlagKey === f.flagKey">
            <td colspan="7" class="grants-panel">
              <div class="grants-panel-header">
                <span>Grants for <strong>{{ f.displayName }}</strong></span>
                <button class="close-btn" (click)="$event.stopPropagation(); expandedFlagKey = null">✕ Close</button>
              </div>

              <div *ngIf="grantsLoading" class="admin-loading">Loading grants…</div>

              <div *ngIf="!grantsLoading" class="grants-cols">

                <div class="grants-col">
                  <h4 class="grants-heading">User Whitelist</h4>
                  <table class="grants-table" *ngIf="expandedUserGrants.length > 0">
                    <tr *ngFor="let g of expandedUserGrants">
                      <td>{{ g.userName || g.userId }}</td>
                      <td class="cell-dim">{{ g.userId }}</td>
                      <td class="cell-dim">{{ g.note || '' }}</td>
                      <td><button class="del-btn" (click)="removeUserGrant(g)">✕</button></td>
                    </tr>
                  </table>
                  <div *ngIf="expandedUserGrants.length === 0" class="cell-dim">No user grants.</div>
                  <div class="grant-search-row">
                    <input [(ngModel)]="userSearchTerm" placeholder="Search user name or ID" class="grant-input" />
                    <button class="save-btn" (click)="searchUsers()">Search</button>
                    <span *ngIf="userSearchError" class="admin-error inline">{{ userSearchError }}</span>
                  </div>
                  <div *ngIf="userSearchLoading" class="cell-dim">Searching users…</div>
                  <table *ngIf="userSearchResults.length > 0" class="grants-table">
                    <tr *ngFor="let u of userSearchResults">
                      <td><strong>{{ u.userName || u.userId }}</strong></td>
                      <td class="cell-dim">{{ u.userId }}</td>
                      <td class="cell-dim">{{ u.fleetName || '—' }}</td>
                      <td><button class="save-btn" (click)="chooseUserFromSearch(u)">Use</button></td>
                    </tr>
                  </table>
                  <div *ngIf="!userSearchLoading && userSearchResults.length === 0 && userSearchTerm" class="cell-dim">No matching users.</div>
                  <div class="grant-add-row">
                    <span *ngIf="newUserGrantUserName" class="grant-selected-name">Adding: <strong>{{ newUserGrantUserName }}</strong> ({{ newUserGrantUserId }})</span>
                    <input [(ngModel)]="newUserGrantUserId" placeholder="PSS User ID" class="grant-input" />
                    <input [(ngModel)]="newUserGrantNote"   placeholder="Note (optional)" class="grant-input" />
                    <button class="save-btn" (click)="addUserGrant()">Add</button>
                    <span *ngIf="newUserGrantError" class="admin-error inline">{{ newUserGrantError }}</span>
                  </div>
                </div>

                <div class="grants-col">
                  <h4 class="grants-heading">Fleet Whitelist</h4>
                  <table class="grants-table" *ngIf="expandedFleetGrants.length > 0">
                    <tr *ngFor="let g of expandedFleetGrants">
                      <td>{{ g.fleetName || g.allianceId }}</td>
                      <td class="cell-dim">{{ g.allianceId }}</td>
                      <td class="cell-dim">{{ g.note || '' }}</td>
                      <td><button class="del-btn" (click)="removeFleetGrant(g)">✕</button></td>
                    </tr>
                  </table>
                  <div *ngIf="expandedFleetGrants.length === 0" class="cell-dim">No fleet grants.</div>
                  <div class="grant-search-row">
                    <input [(ngModel)]="fleetSearchTerm" placeholder="Search fleet name" class="grant-input" />
                    <button class="save-btn" (click)="searchFleets()">Search</button>
                    <span *ngIf="fleetSearchError" class="admin-error inline">{{ fleetSearchError }}</span>
                  </div>
                  <div *ngIf="fleetSearchLoading" class="cell-dim">Searching fleets…</div>
                  <table *ngIf="fleetSearchResults.length > 0" class="grants-table">
                    <tr *ngFor="let f of fleetSearchResults">
                      <td><strong>{{ f.fleetName || f.userName || '—' }}</strong></td>
                      <td class="cell-dim">ID: {{ f.userId || '—' }}</td>
                      <td><button class="save-btn" (click)="chooseFleetFromSearch(f)">Use</button></td>
                    </tr>
                  </table>
                  <div *ngIf="!fleetSearchLoading && fleetSearchResults.length === 0 && fleetSearchTerm" class="cell-dim">No matching fleets.</div>
                  <div class="grant-add-row">
                    <span *ngIf="newFleetGrantFleetName" class="grant-selected-name">Adding: <strong>{{ newFleetGrantFleetName }}</strong> (ID: {{ newFleetGrantAllianceId || '?' }})</span>
                    <input [(ngModel)]="newFleetGrantAllianceId" placeholder="Alliance ID" class="grant-input" />
                    <input [(ngModel)]="newFleetGrantFleetName"  placeholder="Fleet name (snapshot)" class="grant-input" />
                    <input [(ngModel)]="newFleetGrantNote"       placeholder="Note (optional)" class="grant-input" />
                    <button class="save-btn" (click)="addFleetGrant()">Add</button>
                    <span *ngIf="newFleetGrantError" class="admin-error inline">{{ newFleetGrantError }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div *ngIf="!flagsLoading && flags.length === 0" class="admin-empty">No feature flags yet.</div>

    <!-- New flag form -->
    <div class="admin-form">
      <h3 class="form-title">Create Feature Flag</h3>
      <div class="form-row">
        <label>Key (slug) <input [(ngModel)]="newFlag.flagKey" placeholder="my_feature" /></label>
        <label>Display Name <input [(ngModel)]="newFlag.displayName" placeholder="My Feature" /></label>
      </div>
      <div class="form-row">
        <label>Description <input [(ngModel)]="newFlag.description" placeholder="Short description" /></label>
        <label>Min Tier Rank <input type="number" [(ngModel)]="newFlag.requiredTierRank" min="0" max="10" /></label>
        <label class="flag-label"><input type="checkbox" [(ngModel)]="newFlag.isEnabled" /> Enabled</label>
      </div>
      <div *ngIf="newFlagError" class="admin-error">{{ newFlagError }}</div>
      <button class="save-btn" (click)="saveNewFlag()" [disabled]="newFlagSaving">
        {{ newFlagSaving ? 'Saving…' : 'Create Flag' }}
      </button>
    </div>

    </ng-container><!-- /flags sub-tab -->

    <!-- ── Grant Groups sub-tab ──────────────────────────────────────────── -->
    <ng-container *ngIf="flagsSubTab === 'groups'">

      <div *ngIf="groupsError" class="admin-error">{{ groupsError }}</div>
      <div *ngIf="groupsLoading" class="admin-loading">Loading…</div>

      <!-- Group list -->
      <div *ngFor="let g of groups" class="group-card">
        <div class="group-head">
          <span class="group-name">{{ g.name }}</span>
          <span class="group-count cell-dim">{{ g.entryCount }} member{{ g.entryCount === 1 ? '' : 's' }}</span>
          <span *ngIf="g.note" class="group-note cell-dim">{{ g.note }}</span>
          <span class="task-spacer"></span>
          <button class="admin-tab" [class.active]="expandedGroupId === g.id" (click)="expandGroup(g)">
            {{ expandedGroupId === g.id ? 'Close' : 'Edit Members' }}
          </button>
          <button class="admin-tab" [class.active]="applyGroupId === g.id"    (click)="applyGroupId === g.id ? closeApplyPanel() : openApplyPanel(g)">
            {{ applyGroupId === g.id ? 'Close Apply' : 'Apply to Flags' }}
          </button>
          <button class="del-btn" (click)="deleteGroup(g)" title="Delete group">✕</button>
        </div>

        <!-- Members panel -->
        <div *ngIf="expandedGroupId === g.id" class="group-members-panel">
          <div *ngIf="groupEntriesLoading" class="admin-loading">Loading members…</div>

          <div *ngIf="!groupEntriesLoading" class="grants-cols">

            <!-- User members -->
            <div class="grants-col">
              <h4 class="grants-heading">Users</h4>
              <table class="grants-table" *ngIf="userGroupEntries.length > 0">
                <tr *ngFor="let e of userGroupEntries">
                  <td>{{ e.entryName || e.entryId }}</td>
                  <td class="cell-dim">{{ e.entryId }}</td>
                  <td><button class="del-btn" (click)="removeGroupEntry(e)">✕</button></td>
                </tr>
              </table>
              <div *ngIf="userGroupEntries.length === 0" class="cell-dim">No users.</div>
              <div class="grant-search-row">
                <input [(ngModel)]="groupUserSearchTerm" placeholder="Search user name or ID" class="grant-input" />
                <button class="save-btn" (click)="searchGroupUsers()">Search</button>
                <span *ngIf="groupUserSearchError" class="admin-error inline">{{ groupUserSearchError }}</span>
              </div>
              <div *ngIf="groupUserSearchLoading" class="cell-dim">Searching…</div>
              <table *ngIf="groupUserSearchResults.length > 0" class="grants-table">
                <tr *ngFor="let u of groupUserSearchResults">
                  <td><strong>{{ u.userName || u.userId }}</strong></td>
                  <td class="cell-dim">{{ u.userId }}</td>
                  <td class="cell-dim">{{ u.fleetName || '—' }}</td>
                  <td><button class="save-btn" (click)="chooseGroupUserFromSearch(u); newGroupEntryType = 'user'">Use</button></td>
                </tr>
              </table>
              <div class="grant-add-row">
                <span *ngIf="newGroupEntryType === 'user' && newGroupEntryName" class="grant-selected-name">
                  Adding: <strong>{{ newGroupEntryName }}</strong> ({{ newGroupEntryId }})
                </span>
                <input [(ngModel)]="newGroupEntryId"   placeholder="PSS User ID"      class="grant-input" />
                <input [(ngModel)]="newGroupEntryName" placeholder="Name (snapshot)"   class="grant-input" />
                <button class="save-btn" (click)="newGroupEntryType = 'user'; addGroupEntry()">Add User</button>
                <span *ngIf="newGroupEntryError" class="admin-error inline">{{ newGroupEntryError }}</span>
              </div>
            </div>

            <!-- Fleet members -->
            <div class="grants-col">
              <h4 class="grants-heading">Fleets</h4>
              <table class="grants-table" *ngIf="fleetGroupEntries.length > 0">
                <tr *ngFor="let e of fleetGroupEntries">
                  <td>{{ e.entryName || e.entryId }}</td>
                  <td class="cell-dim">{{ e.entryId }}</td>
                  <td><button class="del-btn" (click)="removeGroupEntry(e)">✕</button></td>
                </tr>
              </table>
              <div *ngIf="fleetGroupEntries.length === 0" class="cell-dim">No fleets.</div>
              <div class="grant-search-row">
                <input [(ngModel)]="groupFleetSearchTerm" placeholder="Search fleet name" class="grant-input" />
                <button class="save-btn" (click)="searchGroupFleets()">Search</button>
                <span *ngIf="groupFleetSearchError" class="admin-error inline">{{ groupFleetSearchError }}</span>
              </div>
              <div *ngIf="groupFleetSearchLoading" class="cell-dim">Searching…</div>
              <table *ngIf="groupFleetSearchResults.length > 0" class="grants-table">
                <tr *ngFor="let f of groupFleetSearchResults">
                  <td><strong>{{ f.fleetName || f.userName || '—' }}</strong></td>
                  <td class="cell-dim">ID: {{ f.userId }}</td>
                  <td><button class="save-btn" (click)="chooseGroupFleetFromSearch(f); newGroupEntryType = 'fleet'">Use</button></td>
                </tr>
              </table>
              <div class="grant-add-row">
                <span *ngIf="newGroupEntryType === 'fleet' && newGroupEntryName" class="grant-selected-name">
                  Adding: <strong>{{ newGroupEntryName }}</strong> ({{ newGroupEntryId }})
                </span>
                <input [(ngModel)]="newGroupEntryId"   placeholder="Alliance ID"          class="grant-input" />
                <input [(ngModel)]="newGroupEntryName" placeholder="Fleet name (snapshot)" class="grant-input" />
                <button class="save-btn" (click)="newGroupEntryType = 'fleet'; addGroupEntry()">Add Fleet</button>
              </div>
            </div>

          </div><!-- /grants-cols -->
        </div><!-- /members panel -->

        <!-- Apply-to-flags panel -->
        <div *ngIf="applyGroupId === g.id" class="group-apply-panel">
          <h4 class="grants-heading">Apply "{{ g.name }}" to flags — tick the flags to receive its members</h4>
          <div *ngIf="flags.length === 0" class="cell-dim">No flags available.</div>
          <div class="apply-flags-grid">
            <label *ngFor="let f of flags" class="apply-flag-label">
              <input type="checkbox"
                     [checked]="applyGroupFlagKeys.has(f.flagKey)"
                     (change)="toggleApplyFlag(f.flagKey)" />
              {{ f.displayName }}
              <span class="cell-dim">({{ f.flagKey }})</span>
            </label>
          </div>
          <div class="apply-actions">
            <button class="save-btn" (click)="applyGroupToFlags()" [disabled]="applyGroupLoading || applyGroupFlagKeys.size === 0">
              {{ applyGroupLoading ? 'Applying…' : 'Apply to ' + applyGroupFlagKeys.size + ' flag(s)' }}
            </button>
            <span *ngIf="applyGroupError"   class="admin-error inline">{{ applyGroupError }}</span>
            <span *ngIf="applyGroupSuccess" class="apply-success">{{ applyGroupSuccess }}</span>
          </div>
        </div>

      </div><!-- /group-card -->

      <div *ngIf="!groupsLoading && groups.length === 0" class="admin-empty">No grant groups yet.</div>

      <!-- Create group form -->
      <div class="admin-form">
        <h3 class="form-title">Create Grant Group</h3>
        <p class="form-hint">A grant group is a saved list of users and/or fleets. Use "Apply to Flags" to bulk-whitelist the whole group across any flags you choose.</p>
        <div class="form-row">
          <label>Name <input [(ngModel)]="newGroup.name" placeholder="e.g. Beta Testers" /></label>
          <label>Note <input [(ngModel)]="newGroup.note" placeholder="Optional description" /></label>
        </div>
        <div *ngIf="newGroupError" class="admin-error">{{ newGroupError }}</div>
        <button class="save-btn" (click)="saveNewGroup()" [disabled]="newGroupSaving">
          {{ newGroupSaving ? 'Saving…' : 'Create Group' }}
        </button>
      </div>

    </ng-container><!-- /groups sub-tab -->

  </section>
</div>
